import styled from '@emotion/styled'
import { Avatar, Button, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import React from 'react'
import theme from '../theme'
import ViewProfile from './ViewProfile'

const Input = styled('input')({
    display: 'none',
})

const useStyles = theme;

export default function ProfileAvatar({ imageLnk, name, desig, uni, group, desc, profLnk }) {
    const styles = useStyles();
    const classes = styles;
    return (
        <React.Fragment>
            <Stack direction={"column"} alignContent={'center'} justifyContent={'center'} alignSelf={'center'} alignItems={'center'} spacing={0.5}>
                <Avatar className={classes.avatar} sx={{ height: 190, width: 190 }} src={imageLnk} />
                <Typography variant='body1' fontWeight={'bold'}>{name}</Typography>
                <Typography variant='body1' color={"#0b2c7d"} flexWrap={"wrap"} sx={{maxWidth:'200px'}}>{desig + (uni? " | " + uni: "") + (group == undefined ? "" : " | " + group)}</Typography>
                <ViewProfile name={name} dp={imageLnk} description={desc} profileLnk={profLnk}/>
                {/* <Button variant='contained' style={{ background: "#133F49", width: '150px' }} name={name} dp={imageLnk}>View Profile</Button> */}
                {/* <Typography variant='caption'>{uni}</Typography> */}
            </Stack>
        </React.Fragment>
    )
}